<template>
  <div>
    <Breadcrumb separator=">">
      <span v-for="(item,index) in $store.state.breadList" :key="index">
        <BreadcrumbItem
          v-if="item.url"
          :to="item.query ? {name:item.url,query:item.query} : {name: item.url}"
        >{{item.title}}</BreadcrumbItem>
        <BreadcrumbItem v-else>{{item.title}}</BreadcrumbItem>
      </span>
    </Breadcrumb>
  </div>
</template>

<script>
export default {
  name: "BreadCrumb"
};
</script>

<style scoped>
.ivu-breadcrumb {
  padding: 5px 20px;
  text-align: left;
  border-bottom: 1px solid #ccc;
}
</style>